import React from 'react';
import styles from './ReportListItemFallback.module.scss';
import { SFCard, SFSpinner } from 'sfui';

export const ReportListItemFallback = (): React.ReactElement<{}> => {
  return (
    <SFCard className={styles.reportListItemFallback} sfElevation={2}>
      <SFSpinner />
    </SFCard>
  );
};
